module.exports = __webpack_public_path__ + "img/volume_off.3d0bfff7.svg";